import {computed, Directive, inject, input, OnDestroy} from '@angular/core';
import {MapLayer} from '../map-layer';
import {filter} from 'rxjs';
import {MapService} from '../../../services/map.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {GenServiceType} from '../../../generated/serverModels/GenServiceType';
import BaseLayer from 'ol/layer/Base';

@Directive()
export abstract class BaseUILayer<L extends object = BaseLayer> implements OnDestroy {
  public mapLayer = input.required<MapLayer<L>>();

  protected iconConfig = computed(() => {
    return {
      info: this.mapLayer().description !== undefined,
      download: false,
      identify: this.mapLayer().serviceType === GenServiceType.WMS,
    };
  });




  public checked: boolean = false;
  public opacity: number = 80;
  protected mapService = inject(MapService);

  abstract toggleLayer(checked: boolean, zoomToFeatures?: boolean): void

  abstract onDestroy(): void;

  protected constructor() {
    this.mapService.clearActiveLayers
      .pipe(
        filter(() => this.checked),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.toggleLayer(false);
      });
  }

  ngOnDestroy(): void {
    this.onDestroy();
  }


  public changeOpacity(value: number): void { this.opacity = value; }
}
